import { FC, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Modal from '@/components/organisms/modal'
import { Flex } from '@/components/atoms/Grid'
import { BlackProductSizeBox } from '@/components/molecules/productSizeBox'
import { ConfirmButton } from '@/components/atoms/button'
import { ProductSize } from '@/network/graphql.g'

type ModalContentProps = {
  sizes: ProductSize[]
  initialSelectedSizeId?: string
  onDidTapClose: () => void
  onDidChooseSize: (id: string) => void
  onDidConfirm: () => void
}

const ProductDetailSizesModalContent: FC<ModalContentProps> = ({
  sizes,
  initialSelectedSizeId,
  onDidTapClose,
  onDidChooseSize,
  onDidConfirm
}) => {
  const [selectedSizeId, setSelectedSizeId] = useState<string>(
    initialSelectedSizeId
  )
  const { t } = useTranslation('common')
  return (
    <Modal
      title={t('ProductDetail.Sizes.chooseSize')}
      onDidTapClose={onDidTapClose}
    >
      <Flex
        flexWrap="wrap"
        justifyContent="center"
        mt={10}
        data-testid="productDetailSizesModalBox"
      >
        {sizes &&
          sizes.map(({ id, value }) => (
            <BlackProductSizeBox
              isSelected={selectedSizeId === id}
              mb={10}
              mr={10}
              value={value}
              key={id}
              onClick={() => {
                setSelectedSizeId(id)
                onDidChooseSize(id)
              }}
              data-testid="productDetailSizeModal"
            />
          ))}
      </Flex>
      <ConfirmButton
        px={{ desktop: 80, tablet: 80, mobile: 10 }}
        mt="8px"
        width="100%"
        title={t('ProductDetail.confirmSelection').toUpperCase()}
        onClick={onDidConfirm}
        isDisabled={selectedSizeId === undefined}
        data-testid="confirmChooseSize"
      />
    </Modal>
  )
}

export default ProductDetailSizesModalContent
